module.exports = __webpack_public_path__ + "public/fonts/Graphik-Medium.otf";